import "./App.css";
import Layout from "./components/Layouts/Layout";

function App() {
  return <Layout/>;
}

export default App;
